import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";
import Link from "next-intl/link"
import {StrapiMenu} from "@/app/types/strapi.types";

interface DesktopNavigationProps {
    menu: StrapiMenu
    textClass: string
    scope?: string
}

export default function DesktopNavigation(props: DesktopNavigationProps ) {
    const pathname = usePathname();

    const firstPath = pathname.split("/").at(1);

    return (
        <>
            <nav className="ml-auto hidden lg:block">
                <ul className={`flex list-none xl:text-md font-medium 2xl:text-base ${props.textClass}`}>
                    {props.menu.items.data.map((topLevelMenuItem, index: number) => (
                        <li key={index} className={`px-5 ${topLevelMenuItem.attributes.children.data.length > 0 && "group hover:cursor-pointer relative"}`}>
                            {topLevelMenuItem.attributes.children.data.length > 0 ? (
                                <>
                                    {topLevelMenuItem.attributes.title}
                                    <FontAwesomeIcon icon={faAngleDown} className="ml-1 relative top-[2px]" />
                                </>
                            ) : (
                                <Link key={index} href={`${props.scope === "business" && firstPath =="account" ? "/business" : ""}${topLevelMenuItem.attributes.url}`} title={topLevelMenuItem.attributes.title} className="mb-3 last:mb-0 hover:text-primary">
                                    {topLevelMenuItem.attributes.title}
                                </Link>
                            )}

                            {topLevelMenuItem.attributes.children.data.length > 0 ? (
                                <div className="hidden group-hover:flex group-hover:cursor-pointer flex-col absolute text-base bg-white top-full left-5 p-6 py-5 rounded-lg border-black min-w-[300px] shadow-[0px_3px_6px_rgba(0,0,0,0.15)] text-offblack">
                                    {topLevelMenuItem.attributes.children.data.map((childrenMenuItem, index: number) => (
                                        <Link key={index} href={`${props.scope === "business" && firstPath =="account" ? "/business" : ""}${childrenMenuItem.attributes.url}`} title={childrenMenuItem.attributes.title} className="mb-3 last:mb-0 hover:text-primary">{childrenMenuItem.attributes.title}</Link>
                                    ))}
                                </div>
                            ) : null}
                        </li>
                    ))}
                </ul>
            </nav>

        </>
    )
}
